import React from 'react'
import { language, getTranslatedMessage } from "../utils/translations";

const styles = {
	root: {
		top: 150,
		zIndex: 100,
		width: 200,
		padding: 30,
		borderRadius: 8,
		display: "flex",
		textAlign: "center",
		position: "absolute",
		alignItems: "center",
		background: "#7ca11a",
		flexDirection: "column",
		alignItems: "flex-start",
		[language === "en" ? "left" : "right"]: 70,
		boxShadow: "rgba(0, 0, 0, 0.2) 0px 0.2em 0.8em"
	},
	input: {
		margin: 10,
		padding: 8,
		width: 170,
		fontSize: 16,
		direction: 'ltr',
	},
	button: {
		width: 190,
		backgroundColor: '#ED6D05',
		border: 'solid 1px #ED6D05',
		color: '#ffffff',
		borderRadius: 0,
		padding: '6px 12px',
	}
}

export class SendTranscriptDialog extends React.Component {
	state = {
		email: "",
	}
	handleChangeEmail = ({target: {value}}) => {
		this.setState({email: value})
	}
	handleSubmit = event => {
		event.preventDefault();
		this.props.onSend(this.state.email);
	}
	render() {
		return (
			<div
				style={styles.root}
			>
				<div style={{color: "white"}}>{getTranslatedMessage("send transcript dialog")}</div>
				<form onSubmit={this.handleSubmit} >
					<input name="email" type="email" style={styles.input} onChange={this.handleChangeEmail} placeholder="name@domain.com" />
					<button type="submit" style={styles.button}>{getTranslatedMessage("send")}</button>
				</form>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/SendTranscriptDialog.js